"use strict";

function getBundledProductsFromDom() {
  return Array.from(document.querySelectorAll(".bundle-item")).map(function (item) {
    var pidEl = item.querySelector(".product-id");
    var qtyLabel = item.querySelector("label.quantity");
    var pid = pidEl ? pidEl.textContent.trim() : undefined;
    var qty = 1;
    if (qtyLabel) {
      qty = parseInt(qtyLabel.getAttribute("data-quantity"), 10);
    }
    return {
      pid: pid,
      quantity: Number.isNaN(qty) ? 1 : qty
    };
  });
}
function getSelectedQuantityFromDom() {
  var bundleQtyEl = document.querySelector(".bundle-footer .quantity-select");
  if (bundleQtyEl) return bundleQtyEl.value;
  var qtyEl = document.querySelector(".quantity-select");
  return qtyEl ? qtyEl.value : 1;
}
function computeBundledProducts(initialBundledProducts, isBundlePdp) {
  if (!isBundlePdp) return initialBundledProducts || [];
  if (initialBundledProducts && Array.isArray(initialBundledProducts)) {
    return initialBundledProducts;
  }
  return getBundledProductsFromDom();
}
function isBundleDetailPage() {
  return Boolean(document.querySelector(".product-bundle") || document.querySelector(".bundle-item"));
}
function buildTemporaryBasketPayload(parsedData) {
  var id = parsedData.id,
    options = parsedData.options,
    initialBundledProducts = parsedData.bundledProducts,
    initialSelectedQuantity = parsedData.selectedQuantity;
  var bundledProducts = computeBundledProducts(initialBundledProducts, isBundleDetailPage());
  var selectedQuantity = initialSelectedQuantity || getSelectedQuantityFromDom();
  return {
    id: id,
    bundledProducts: bundledProducts,
    options: options,
    selectedQuantity: selectedQuantity
  };
}
module.exports = {
  buildTemporaryBasketPayload: buildTemporaryBasketPayload
};